


import {GameRoundPresentation} from "@nolimitcity/slot-game/bin/timelinegameround/core/gameround/GameRoundPresentation";
import {HarlequinParsedGameData} from "../../server/data/HarlequinParsedGameData";
import {Timeline, TimelineLite} from "gsap";
import {HarlequinGameModuleConfig} from "../../HarlequinGameModuleConfig";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {HarlequinSoundConfig} from "../../HarlequinSoundConfig";
import {GameRoundManager} from "@nolimitcity/slot-game/bin/timelinegameround/core/gameround/GameRoundManager";

export class HarlequinAddFreespin implements GameRoundPresentation {


    private _hasWin:boolean = false;
    private _tl:Timeline;
    private _plusOnePositions:number [][] = [];
    private _freespinsAddCounter:number;
    private _endDelay:number = 0.5;
    private _freespinsAwarded:number;
    private _scattersCollectedFSAfter:number;
    private _scattersCollectedFSBefore:number;
    private _collectValue:number = 0;
    private _updatedThisSpin:boolean = false;
    private _aborted = false;
    private _runningWhile:boolean = false;
    private _added:boolean = false;

    constructor() {

    }

    prepare(data:HarlequinParsedGameData) {
        this._added = false;
        this._runningWhile = false;
        this._aborted = false;
        this._updatedThisSpin = false;
        this._collectValue = 0;
        this._hasWin = (data.extraSpinsAwardedThisSpin > 0);
        this._plusOnePositions.length = 0;
        this._freespinsAwarded = data.extraSpinsAwardedThisSpin;
        this._freespinsAddCounter = data.freespinsLeft - data.extraSpinsAwardedThisSpin;

        this._scattersCollectedFSAfter = data.scattersCollectedFSAfter;
        this._scattersCollectedFSBefore = data.scattersCollectedFSBefore;


        /**
         betLineWins: (4) [{…}, {…}, {…}, {…}]
         totalBetLineWins: 31.35
         totalSpinWinnings: 31.35
         accumulatedRoundWin: 31.35
         playedBetValue: 1
         nearWinReels: (5) [false, false, false, false, false]
         reelsNextSpin: "WILD_RESPIN_FS_REELSET"
         mode: "FREESPIN"
         nextMode: "WILD_RESPIN_FS"
         freespinTriggeredThisSpin: false
         freespinPlayed: 3
         freespinsLeft: 12
         scatterPositions: (5) [-1, 1, 0, 2, -1]
         reelsEnteringFreespin: (5) [Array(5), Array(5), Array(5), Array(5), Array(5)]
         wildOverlaysBefore: (5) [false, false, false, false, false]
         wildOverlayReels: (5) [false, false, false, false, true]
         wildMultipliersBefore: (5) [0, 0, 0, 0, 0]
         wildMultipliers: (5) [0, 0, 0, 0, 3]
         scattersCollected: 0
         wildsCollected: (5) [0, 0, 0, 0, 0]
         respinActive: true
         doReelNudge: (5) [false, false, false, false, false]
         extraSymbolsOnTop: (5) [Array(3), Array(3), Array(3), Array(3), Array(3)]
         scattersFSCollectedBefore: (5) [0, 0, 0, 0, 0]
         scattersFSCollectedAfter: (5) [0, 0, 0, 0, 0]
         extraScatterThisFSSpin: Array(5)
         0: 0
         1: 1
         2: 1
         3: 1
         4: 0
         */

        if(this._hasWin && data.scatterPositions) {

            data.scatterPositions.forEach((sid, rid) => {
                if(sid > -1) {
                    this._plusOnePositions.push([rid, sid]);
                }
            });
        }
    }

    public getAnimation():Timeline {
        const tl:TimelineLite = new TimelineLite();

        if(this._hasWin) {


            /* TODO: In the case of collecting several wilds in the same round as Wild Drop, we need to add the extra ones, after wildrop, sequence as follows:
                wild land
                win presentations
                attention on wilds
                indicator lit, up to full "bar"
                bar drop down -> wild drop
                collect any leftovers
            */
            this._collectValue = this._scattersCollectedFSBefore;
            let litCount:number = this._scattersCollectedFSBefore;

            if(!this._updatedThisSpin) {
                this._updatedThisSpin = true;

                if(!this._runningWhile) {
                    this._runningWhile = true;
                    while (this._plusOnePositions.length > 0) {
                        const position: number [] = this._plusOnePositions.shift() || [];
                        const nr:number = ++this._freespinsAddCounter;

                        /**
                         let collect:number = this._collectValue;
                         if(collect < 3) {
                            collect++;
                        } else {
                            collect = 0;
                        }
                         */

                        if (litCount <= 2) {
                            this._endDelay += 0.2;
                            tl.add([
                                () => {
                                    this._updatedThisSpin = true;
                                    SlotGame.keypad.setZeroBetSpinCounter(nr);
                                    //EventHandler.dispatchEvent(new GameEvent(KeypadEvent.SET_FREESPINS_LEFT, ++this._freespinsAddCounter));
                                },
                                (!this._added && !this._aborted) ? HarlequinGameModuleConfig.plusOneView.createPlusOneForPos(position[0], position[1], this._aborted) : () => {},
                                () => this._added = true
                            ], "+=0.2");
                            tl.add([
                                () => {
                                    let col:number = 0;
                                    HarlequinGameModuleConfig.harlequinScatterCollectorView.updateIndicator((this._collectValue < 3) ? col = this._collectValue++ : 0);
                                    SlotGame.sound.playEffect(HarlequinSoundConfig.instance.SCATTER_COLLECT);
                                    this._aborted = true
                                    if(col >= 3) {
                                        this._endDelay -= 0.2;
                                    }
                                }
                                //HarlequinGameModuleConfig.harlequinScatterCollectorView.litNext(true).timeline
                            ], "+=0");
                        } else {
                            HarlequinGameModuleConfig.harlequinScatterCollectorView.addToPlusOnePosition(position);
                        }
                        litCount++;
                    }
                }

                //this._plusOnePositions.forEach((position: number [], index) => {
                //});
                //this._plusOnePositions.length = 0;
            }
            tl.add(() => {
                //SlotGame.keypad;
            }, "+=" + this._endDelay)

            //console.log("+1 POSITIONS");
            //console.log(this._plusOnePositions);
        }
        this._tl = tl;
        return tl;
    }

    abort(isActive: boolean, data: HarlequinParsedGameData): Timeline | null {
        if(!this._aborted && this._tl) {
            this._aborted = true;
            return this._tl;
        }
        else if(!this._aborted){
            this._aborted = true;
            GameRoundManager.detachAndPlayTimeline(this._tl);
            /*if(this._hasWin && !this._aborted) {
                const tl:Timeline =  this.getAnimation();
                this._aborted = true;
                return tl;
            }*/
        }
        /*
         if(isActive && this._tl) {
            this._aborted = true;
            GameRoundManager.detachAndPlayTimeline(this._tl);
            //if(this._isFreespinNext) {
            const tl: TimelineLite = new TimelineLite();
            tl.add(() => {}, 1.0);
            return tl;

           // return this._tl;
        }
        else if(!this._aborted) {
            this._aborted = true;
            return this.getAnimation();
            //if(this._isFreespinNext) {
            /*const tl: TimelineLite = new TimelineLite();
            tl.add(() => {}, 1.0);
            return tl;
    }
        }*/
        return null;
    }



}